// src/router/index.js
import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import ForgetPassword from '@/views/ForgetPassword/ForgetPassword.vue';
import ChangePassword from '@/views/ChangePassword/ChangePassword.vue';
import PersonalCenter from '@/views/PersonalCenter.vue';
import { ElMessage } from "element-plus";
// import service from '@/utils/request'; // 替换原生axios，使用封装后的请求实例
import { useUserStore } from '@/store/modules/userStore';
import pinia from '@/store/index.js';

// 平台主页面（导入文件夹，自动识别 JddContentIndex.vue）
const JddContent = () => import('../views/platform/JddContent/JddContentIndex.vue')
const TmmContent = () => import('../views/platform/TmmContent/TmmContentIndex.vue')
const TbbContent = () => import('../views/platform/TbbContent/TbbContentIndex.vue')
const DyyContent = () => import('../views/platform/DyyContent/DyyContentIndex.vue')
const PddContent = () => import('../views/platform/PddContent/PddContentIndex.vue')
const WppContent = () => import('../views/platform/WppContent/WppContentIndex.vue')

// 1. 初始化Pinia实例（非组件环境下使用Pinia的必要步骤）
// const userStore = useUserStore(pinia);

// 2. 补全需要登录的页面meta.requiresAuth（关键：之前MyOrder/MyBill等未标记，导致守卫不拦截）
const routes = [
  // 根路由：默认直接渲染天猫平台（不在地址栏显示 /TmmContent）
  {
    path: '/',
    name: 'Home',
    component: TmmContent,
    meta: {
      title: '天猫优惠券入口-不折不购',
      keywords: '天猫优惠券,天猫优惠入口,天猫购物,隐藏优惠券,返现',
      description: '不折不购提供天猫商品隐藏优惠券入口，领取后跳转天猫下单，购物返现更优惠'
    }
  },
  // 东啊东平台（带专属子路由）
  {
    path: '/JddContent',
    name: 'JddContent',
    component: JddContent,
    meta: {
      title: '京东优惠券入口-不折不购',
      keywords: '京东优惠券,京东优惠入口,京东购物',
      description: '提供京东商品隐藏优惠券入口，领取后跳转京东下单'
    }
  },
  // 猫啊猫平台（暂无子路由，留空数组）
  {
    path: '/TmmContent',
    name: 'TmmContent',
    component: TmmContent,
    meta: {
      title: '天猫优惠券入口-不折不购',
      keywords: '天猫优惠券,天猫优惠入口,天猫购物',
      description: '提供天猫商品隐藏优惠券入口，领取后跳转天猫下单'
    }
  },
  // 淘啊淘平台
  {
    path: '/TbbContent',
    name: 'TbbContent',
    component: TbbContent,
    meta: {
      title: '淘宝优惠券入口-不折不购',
      keywords: '淘宝优惠券,淘宝优惠入口,淘宝购物',
      description: '提供淘宝商品隐藏优惠券入口，领券下单更优惠'
    }
  },
  // 抖啊抖平台
  {
    path: '/DyyContent',
    name: 'DyyContent',
    component: DyyContent,
    meta: {
      title: '抖音优惠券入口-不折不购',
      keywords: '抖音优惠券,抖音优惠入口,抖音购物',
      description: '提供抖音小店商品优惠券入口'
    }
  },
  // 拼啊拼平台
  {
    path: '/PddContent',
    name: 'PddContent',
    component: PddContent,
    meta: {
      title: '拼多多优惠券入口-不折不购',
      keywords: '拼多多优惠券,拼多多优惠入口,拼多多购物',
      description: '提供拼多多商品隐藏优惠券入口'
    }
  },
  // 唯啊唯平台
  {
    path: '/WppContent',
    name: 'WppContent',
    component: WppContent,
    meta: {
      title: '唯品会优惠券入口-不折不购',
      keywords: '唯品会优惠券,唯品会优惠入口,唯品会购物',
      description: '提供唯品会品牌商品优惠券入口'
    }
  },
  // 登录/注册路由
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginB.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/RegisterB.vue'),
    meta: { title: '注册' }
  },
  {
    path: '/searchresult',
    name: 'SearchResult',
    component: () => import('@/views/SearchResult.vue'),
    meta: {
      noCommonHeader: true,
      title: '搜索结果-不折不购',
      keywords: '商品搜索,优惠券搜索,比价搜索',
      description: '不折不购商品搜索，帮您找到各平台隐藏优惠券和最优价格'
    }
  },
  {
    path: '/forgetPassword',
    component: ForgetPassword,
    meta: { title: '忘记密码' }
  },
  {
    path: '/changePassword',
    component: ChangePassword,
    meta: { title: '修改密码', requiresAuth: true }
  },
  // 个人中心（补充requiresAuth：需要登录才能访问）
  {
    path: '/PersonalCenter',
    name: 'PersonalCenter',
    component: PersonalCenter,
    meta: { title: '个人中心', requiresAuth: true }
  },
  // 我的收藏页面路由（游客可访问，内部判断登录态，保持requiresAuth: false）
  {
    path: '/favorite',
    name: 'Favorite',
    component: () => import('@/views/FavoriteList.vue'),
    meta: {
      title: '我的收藏',
      requiresAuth: false
    }
  },
  // 我的订单页面路由（补充requiresAuth：核心需要登录的页面）
  {
    path: '/MyOrder',
    name: 'MyOrder',
    component: () => import('@/views/MyOrder.vue'),
    meta: { title: '我的订单', requiresAuth: false }
  },

  {
    path: '/MyBill',
    name: 'MyBill',
    component: () => import('@/views/MyBill.vue'),
    meta: { title: '省钱账单', requiresAuth: false }
  },

  // 提现页面
  {
    path: '/Withdraw',
    name: 'Withdraw',
    component: () => import('@/views/Withdraw/Withdraw.vue'),
    meta: { title: '提现', requiresAuth: true }
  },

  {
    path: '/GetCoupons',
    name: 'GetCoupons',
    component: () => import('@/views/GetCoupons.vue'),
    meta: {
      title: '领券通道-隐藏优惠券汇总-不折不购',
      keywords: '领券通道,隐藏优惠券,优惠券汇总,京东优惠券,淘宝优惠券,天猫优惠券',
      description: '不折不购领券通道，汇集京东、淘宝、天猫、拼多多等平台隐藏优惠券，一站式领取更方便',
      requiresAuth: false
    }
  },
  // 省钱攻略
  {
    path: '/Strategy',
    name: 'Strategy',
    component: () => import('@/views/Strategy.vue'),
    meta: {
      title: '攻略中心-购物省钱攻略-不折不购',
      keywords: '购物攻略,省钱技巧,优惠券使用攻略',
      description: '不折不购购物攻略中心，分享各类商品的省钱购买技巧和优惠券使用攻略',
      requiresAuth: false,
      noCommonHeader: true
    }
  },
  // 攻略详情
  {
    path: '/StrategyDetail/:id',
    name: 'StrategyDetail',
    component: () => import('@/views/StrategyDetail.vue'),
    meta: {
      title: '攻略详情-不折不购',
      keywords: '购物攻略,省钱技巧',
      description: '不折不购攻略详情，帮您了解更多省钱购物技巧',
      requiresAuth: false,
      noCommonHeader: true
    }
  },

  // 文章管理
  {
    path: '/admin/article/list',
    name: 'AdminArticleList',
    component: () => import('@/views/admin/AdminArticleList.vue'),
    meta: { title: '文章管理', requiresAuth: true }
  },
  {
    path: '/admin/article/write',
    name: 'AdminArticleWrite',
    component: () => import('@/views/admin/AdminArticleEditor.vue'),
    meta: { title: '写文章', requiresAuth: true }
  },
  {
    path: '/admin/article/edit/:id',
    name: 'AdminArticleEdit',
    component: () => import('@/views/admin/AdminArticleEditor.vue'),
    meta: { title: '编辑文章', requiresAuth: true }
  },

  // 账号设置
  {
    path: '/accountsetting',
    name: 'AccountSetting',
    component: () => import('@/views/AccountSetting.vue'),
    meta: { title: '账号设置', requiresAuth: true }
  },
  // 账号设置子路由 - 个人信息
  {
    path: '/accountsetting/profile',
    name: 'ProfileSetting',
    component: () => import('@/views/account/ProfileSetting.vue'),
    meta: { title: '个人信息', requiresAuth: true }
  },
  // 账号设置子路由 - 头像编辑
  {
    path: '/accountsetting/avatar-edit',
    name: 'AvatarEdit',
    component: () => import('@/views/account/AvatarEdit.vue'),
    meta: { title: '编辑头像', requiresAuth: true }
  },
  // 账号设置子路由 - 账号安全
  {
    path: '/accountsetting/security',
    name: 'SecuritySetting',
    component: () => import('@/views/account/SecuritySetting.vue'),
    meta: { title: '账号安全', requiresAuth: true }
  },
  // 账号设置子路由 - 注销账号
  {
    path: '/accountsetting/security/cancel-account',
    name: 'CancelAccount',
    component: () => import('@/views/account/CancelAccount.vue'),
    meta: { title: '注销账号', requiresAuth: true }
  },
  // 账号设置子路由 - 账号绑定
  {
    path: '/accountsetting/bind',
    name: 'BindSetting',
    component: () => import('@/views/account/BindSetting.vue'),
    meta: { title: '账号绑定', requiresAuth: true }
  },
  // 账号设置子路由 - 提现账号绑定（授权模式）
  {
    path: '/accountsetting/bind-account',
    name: 'BindAccount',
    component: () => import('@/views/account/BindAccount.vue'),
    meta: { title: '提现账号绑定', requiresAuth: true }
  },
  // 账号设置子路由 - 收货地址
  {
    path: '/accountsetting/address',
    name: 'AddressSetting',
    component: () => import('@/views/account/AddressSetting.vue'),
    meta: { title: '收货地址', requiresAuth: true }
  },
  // 账号设置子路由 - 新增/编辑地址
  {
    path: '/accountsetting/address/edit/:id?', // id可选，新增时不传
    name: 'AddressEdit',
    component: () => import('@/views/account/AddressEdit.vue'),
    meta: { title: '编辑收货地址', requiresAuth: true }
  }
]

// 动态选择路由模式：PC端用History，App端用Hash
const router = createRouter({
  history: process.env.VUE_APP_PLATFORM === 'app'
    ? createWebHashHistory(process.env.BASE_URL)
    : createWebHistory(process.env.BASE_URL),
  routes
})

// 3. 全局路由守卫（适配Pinia，替换本地存储直接读取逻辑）
router.beforeEach(async (to, from, next) => {
  // 仅拦截需要登录认证的页面
  if (to.meta.requiresAuth) {
    try {
      const userStore = useUserStore(pinia);
      // 核心：调用Pinia仓库的统一初始化方法，同步全局登录状态
      // 替代原本手动读取localStorage/JSON.parse的零散逻辑
      await userStore.initUserStatus();

      // 核心：从Pinia仓库获取统一的登录状态（使用getters或直接取state，保证逻辑一致）
      const isLogin = userStore.hasLogin; // 优先使用仓库的getters，更严谨

      if (isLogin) {
        // 已登录：检查accessToken是否有效，缺失则依赖request.js的拦截器自动刷新
        // 无需手动发起刷新请求，避免与request.js的刷新逻辑冲突
        next();
      } else {
        // 未登录：跳转登录页，记录返回地址
        ElMessage.warning('请先登录后再访问！');
        // 防护：若目标本身就是登录/注册页，则不要将 redirect 设为该页面，避免循环重定向
        const target = (to.fullPath || '').toLowerCase();
        const redirectPayload = (target.startsWith('/login') || target.startsWith('/register'))
          ? { path: '/login' }
          : { path: '/login', query: { redirect: to.fullPath } };
        // 调试日志：输出守卫决策，便于排查循环跳转
        try { console.log('[Router Guard] redirecting to login, target:', to.fullPath, 'payload:', redirectPayload); } catch(e) { console.warn('[Router Guard] logging failed', e) }
        next(redirectPayload);
      }
    } catch (error) {
      // 初始化状态失败（如接口异常），强制跳转登录页
      console.error('【路由守卫】初始化用户状态失败：', error);
      ElMessage.error('身份验证失败，请重新登录');
      const userStore = useUserStore(pinia);
      userStore.resetUserStatus(); // 重置Pinia全局状态
      next({ path: '/login', query: { redirect: to.fullPath } });
    }
  } else {
    // 无需登录的页面，直接放行
    next();
  }
})

// 全局后置日志（调试用）
router.afterEach((to, from) => {
  try { console.log('[Router] afterEach from', from.fullPath, '-> to', to.fullPath, 'query:', to.query); } catch (e) { console.warn('[Router] afterEach logging failed', e) }
});

// 后置守卫：统一设置页面标题和SEO meta标签
router.afterEach((to) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = '不折不购-专注省钱';
  }

  // 设置SEO meta标签
  const keywords = to.meta.keywords || '优惠券,隐藏优惠券,返现,省钱,购物优惠';
  const description = to.meta.description || '不折不购-专注寻找隐藏优惠券，让您购物折上折';

  // 更新或创建meta标签
  updateMetaTag('keywords', keywords);
  updateMetaTag('description', description);

  // 百度统计页面浏览量跟踪
  if (window._hmt) {
    window._hmt.push(['_trackPageview', to.fullPath]);
  }
});

// 辅助函数：更新meta标签
function updateMetaTag(name, content) {
  let meta = document.querySelector(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = name;
    document.head.appendChild(meta);
  }
  meta.content = content;
}

export default router
